export default __webpack_public_path__ + "static/media/Indeedlogo.96503211.svg";